<template>
    <div id="main" ref="cockpit" :class="{ 'no-charts': !showCharts }">
        <div class="page">
            <!-- Barra Superior -->
            <div class="columns chart-toolbar is-multiline z-index-1">
                <!-- COLLAPSE DO FILTRO -->
                <div class="column">
                    <b-collapse class="card" :open="false">
                        <div slot="trigger" slot-scope="props" class="card-header is-paddingless">
                            <div class="card-header-title">
                                <div class="filtro-header">
                                    <b-icon
                                        :icon="props.open ? 'menu-down' : 'menu-right'"
                                    ></b-icon>
                                    <span class="is-size-7">{{ $t('filtros') }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="columns is-multiline is-variable is-2">
                                <!-- COMBOS TIPO, VENDEDORES E EMPRESA -->
                                <div
                                    class="column is-full-touch is-full-desktop is-full-widescreen is-two-thirds-fullhd"
                                >
                                    <div class="columns is-variable is-2">
                                        <div v-if="empresas.length > 0" class="column">
                                            <label>
                                                {{ $t('empresas') }}
                                                <b-icon
                                                    icon="information"
                                                    size="is-small"
                                                    v-tippy
                                                    :title="$t('label-filtro-adiantamento-chart')"
                                                />
                                            </label>
                                            <vss-select
                                                v-model="empresasInner"
                                                label="rsocial"
                                                compareId
                                                :options="empresas"
                                                :closeOnSelect="false"
                                                @input="clearSelect($event, 'emrpesas')"
                                                no-clearfix
                                                multiple
                                                clearable
                                            >
                                                <template #multiple-selected="{ selected }">
                                                    ({{
                                                        selected && selected.length > 0
                                                            ? selected.length
                                                            : $t('todos')
                                                    }})
                                                </template>
                                            </vss-select>
                                        </div>
                                        <div v-if="vendedores.length > 0" class="column">
                                            <label
                                                ><span>{{ $t('vendedores') }}</span></label
                                            >
                                            <vss-select
                                                v-model="vendedoresInner"
                                                label="nome"
                                                compareId
                                                :options="vendedores"
                                                :loading="vendedoresLoading"
                                                @search="loadVendedores"
                                                @input="clearSelect($event, 'vendedores')"
                                                :closeOnSelect="false"
                                                no-clearfix
                                                multiple
                                                clearable
                                                searchable
                                            >
                                                <template #multiple-selected="{ selected }">
                                                    ({{
                                                        selected && selected.length > 0
                                                            ? selected.length
                                                            : $t('todos')
                                                    }})
                                                </template>
                                            </vss-select>
                                        </div>
                                    </div>
                                </div>

                                <!-- DATAS -->
                                <div
                                    class="column is-full-touch is-full-desktop is-full-widescreen is-one-third-fullhd"
                                >
                                    <div class="columns is-variable is-2">
                                        <div class="column">
                                            <verified-date-picker
                                                :dateType="'startDate'"
                                                v-model="datainicio"
                                                :endDate="datafim"
                                                :subtractDateYears="80"
                                                :title="'data-inicio'"
                                            />
                                        </div>
                                        <div class="column">
                                            <verified-date-picker
                                                :dateType="'endDate'"
                                                v-model="datafim"
                                                :startDate="datainicio"
                                                :title="'data-fim'"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-collapse>
                </div>

                <!-- BOTÕES -->
                <div class="column is-narrow">
                    <b-button class="top-btn" type="is-light" @click="saveFiltros">
                        <span class="has-text-weight-bold is-size-7">
                            {{ $t('aplicar-filtros') }}
                        </span>
                    </b-button>

                    <b-button class="top-btn" type="is-light" @click="confirmCleanFilters">
                        <span class="has-text-weight-bold is-size-7">
                            {{ $t('limpar-filtros') }}
                        </span>
                    </b-button>
                </div>
            </div>

            <!-- Gráficos -->
            <div class="chart-container mt-4 mr-3" ref="PackeryMagic" v-if="showCharts">
                <div class="pkry-gutter"></div>
                <div class="pkry-sizer"></div>
                <div
                    v-for="(d, i) in dataset"
                    :key="i"
                    class="chart"
                    ref="chartItem"
                    :data-title="d.titulo"
                    :data-item-id="i"
                    :class="{
                        'big-number': d && d.tipo == 'bignumber',
                        'line-chart': d && (d.tipo == 'line' || d.tipo == 'bar'),
                    }"
                >
                    <BigNumber
                        :ref="`${d.tipo}-${d.titulo}`"
                        v-if="d && d.tipo == 'bignumber'"
                        :title="$t(d.titulo)"
                        :datacontent="d"
                        :filtro="filtros"
                        :showPercent="false"
                        module="DESPESAS"
                        @update-content="updateChart($event, i)"
                    />
                    <ZoomBarChart
                        :ref="`${d.tipo}-${d.titulo}`"
                        v-if="d && d.tipo == 'bar'"
                        :title="$t(d.titulo)"
                        :datacontent="d"
                        :direction="d.direction"
                        :filtro="filtros"
                        module="DESPESAS"
                        @update-content="updateChart($event, i)"
                    />
                    <DonutChart
                        :ref="`${d.tipo}-${d.titulo}`"
                        v-if="d && d.tipo == 'donut'"
                        :title="$t(d.titulo)"
                        :datacontent="d"
                        :filtro="filtros"
                        module="DESPESAS"
                        @update-content="updateChart($event, i)"
                    />
                </div>
            </div>

            <!-- Página não há dados -->
            <section class="hero is-fullheight" v-else-if="!isLoading">
                <div class="hero-body">
                    <div class="container has-text-centered">
                        <div class="elipse">
                            <svg class="big-svg-icons">
                                <use
                                    :xlink:href="
                                        require('@/assets/img/icons/speedometer.svg') + '#layer'
                                    "
                                ></use>
                            </svg>
                        </div>
                        <p style="margin-top: 10px">
                            {{ $t('cockpit-sem-dados-vendas') }}
                        </p>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import CockpitDespesasService from '@/services/CockpitDespesasService';
import ColaboradorService from '@/services/ColaboradorService';
import DonutChart from '@/components/shared/chart/DonutChart';
import BigNumber from '@/components/shared/chart/BigNumber';
import ZoomBarChart from '@/components/shared/chart/ZoomBarChart';
import $ from 'jquery';
import * as Draggable from 'jquery-ui/ui/widgets/draggable.js';
import Packery from 'packery';
import FiltroCockpitService from '@/services/FiltroCockpitService';

export default {
    computed: {
        showCharts: function () {
            return this.dataset.length > 0;
        },
    },
    components: {
        DonutChart,
        ZoomBarChart,
        BigNumber,
    },
    data() {
        return {
            jqi: $,
            service: new CockpitDespesasService(this.$http, this.$router),
            filtroCockpitService: new FiltroCockpitService(this.$http, this.$router),
            colaboradorService: new ColaboradorService(this.$http, this.$router),
            dataset: [],
            lastSize: { w: 0, h: 0 },
            isLoading: false,
            chartsAvailable: [],
            categorias: [],
            searchSet: [],
            resultSet: [],
            searching: false,
            pckr: null,
            dragOpts: {
                zIndex: 100,
                handle: '.chart-title',
                containment: '.chart-container',
            },
            firstReload: false,
            curScreenSize: 1201,
            prevScreenSize: 1201,
            packeryOpts: {
                itemSelector: '.chart',
                percentPosition: true,
                shiftPercentResize: true,
                transitionDuration: '0.3s',
                gutter: '.pkry-gutter',
                columnWidth: '.pkry-sizer',
            },
            showVendedores: false,
            vendedores: [],
            vendedoresInner: [],
            vendedoresLoading: false,
            empresas: [],
            empresasInner: [],
            filtroList: [],
            filtros: {
                empresas: [],
                vendedores: [],
                /*  Para as datas, seta o valor inicial, se vier algo diferente do banco
                    eles serão sobreescritos após carregar os filtros. */

                /**
                 * @70405 - datainicial -> datainicio
                 * datafinal -> datafim
                 *
                 * Alterado os nomes, pois no back-end ia como null as datas
                 * por que no back era um nome e no front na hora de enviar o json
                 * com os filtros era outro nome.
                 */
                datainicio: null,
                datafim: null,
            },
            vendedoresResultadoAtual: [],
            datainicio: new Date(this.$moment().subtract(30, 'days')),
            datafim: new Date(),
            staticDataInicial: undefined,
            staticDataFinal: undefined,
            permissao: {},
        };
    },
    created() {
        this.empresas = this.fetchEmpresas();
        this.permissao = this.hasPermissionAccess('despesas', 'cockpit', 'des-cockpit');
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'despesas-titulo-cockpit' },
            });
        } else {
            this.carregarDados();
        }
    },
    beforeDestroy() {
        document.body.onresize = null;
    },
    methods: {
        carregarDados() {
            this.staticDataInicial = this.datainicio;
            this.staticDataFinal = this.datafim;
            this.filtros.datainicio = this.datainicio;
            this.filtros.datafim = this.datafim;
            this.isLoading = true;
            this.startVendedores();

            let body = document.getElementsByTagName('body')[0];
            this.curScreenSize = window.innerWidth;
            this.prevScreenSize = window.innerWidth;

            this.lastSize.w = document.body.clientWidth;
            this.lastSize.h = document.body.clientHeight;

            body.onresize = this.debounce(this.resize, 150);
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.debouncedRedraw = this.debounce(this.redrawCharts, 1000);
        },
        getFiltroList() {
            this.filtros.tipoAnalise = this.tipoAnaliseInner;
            let filtros = [];

            filtros.push({
                idfiltro: this.filtros.idfiltroempresa,
                tipo: 'empresa',
                multi: true,
                itens: this.empresasInner.map((e) => Number(e.idempresa)),
            });

            if (this.showVendedores) {
                filtros.push({
                    idfiltro: this.filtros.idfiltrovendedor,
                    tipo: 'vendedor',
                    multi: true,
                    itens: this.vendedoresInner.map((e) => Number(e.idusuario)),
                });
            }
            filtros.push({
                idfiltro: this.filtros.idfiltrotipoanalise,
                tipo: 'tipo-analise',
                multi: false,
                valor: this.filtros.tipoAnalise,
            });
            filtros.push({
                idfiltro: this.filtros.idfiltrodatainicio,
                tipo: 'data-inicio',
                multi: false,
                valor: this.filtros.datainicio,
            });
            filtros.push({
                idfiltro: this.filtros.idfiltrodatafim,
                tipo: 'data-fim',
                multi: false,
                valor: this.filtros.datafim,
            });
            return filtros;
        },
        saveFiltros() {
            let erroFiltro = false;
            // Salva a posição dos filtros após a aplicar ou limpar
            if (this.vendedoresInner.length > 0) {
                this.filtros.vendedores = this.vendedoresInner.map((e) => Number(e.idusuario));
            } else {
                this.filtros.vendedores = [];
            }
            if (this.empresasInner.length > 0) {
                this.filtros.empresas = this.empresasInner.map((e) => Number(e.idempresa));
            } else {
                this.filtros.empresas = this.empresas.map((e) => Number(e.idempresa));
            }
            this.filtros.datainicio = this.datainicio;
            this.filtros.datafim = this.datafim;

            /**
             * @70409 - Verificando se as datas estão vazias.
             */
            if (this.filtros.datainicio == null) {
                this.erroDataInicio = true;
                erroFiltro = true;
            } else {
                this.erroDataInicio = false;
            }

            if (this.filtros.datafim == null) {
                this.erroDataFim = true;
                erroFiltro = true;
            } else {
                this.erroDataFim = false;
            }

            if (erroFiltro) {
                this.$root.showMessage('alert', 'datas-obrigatorias');
                return;
            }

            this.isSavingFilter = true;
            this.filtroList = this.getFiltroList();
            this.filtroCockpitService
                .save(this.filtroList, 'despesas')
                .then((r) => {
                    this.reloadCharts();
                    if (this.vendedoresInner.length > 0) {
                        this.vendedoresResultadoAtual = [...this.vendedoresInner];
                    } else {
                        this.vendedoresResultadoAtual = [...this.vendedores];
                    }
                })
                .catch((e) => {
                    console.error('Erro ao salvar filtros.', e);
                    this.$root.showMessage('error', 'msg-erro-filtros');
                })
                .finally((_) => {
                    this.isSavingFilter = false;
                });
        },
        /*
            @69946 - Caso o usuário troque as informações dos campos nos filtros e não aplica os filtros,
            quando ele clicar em Limpar filtros os campos serão resetados para os valores padrões.
        */
        clearInputs() {
            this.empresasInner = [];
            this.vendedoresInner = [];
            this.filtros.empresas = this.empresas.map((e) => e.id);
            this.filtros.vendedores = this.vendedores.map((e) => e.id);
            this.filtros.datainicio = this.staticDataInicial;
            this.datainicio = this.staticDataInicial;
            this.filtros.datafim = this.staticDataFinal;
            this.datafim = this.staticDataFinal;
            this.existeFiltrosSelecionado = false;
        },
        clearSelect(value, select) {
            if (value.length == 0) {
                if (select == 'empresas') this.empresasInner = [];
                if (select == 'vendedores') this.vendedoresInner = [];
            }
        },
        confirmCleanFilters() {
            if (this.possuiFiltroSelecionado()) {
                this.$root.confirm({
                    message: this.$t('msg-confirm-limpar-filtros'),
                    onConfirm: this.clearFilters,
                });
                // @69946 - Caso não tenha filtros selecionado chama a função para limpar os campos para os valores padrões.
            } else {
                this.clearInputs();
            }
        },
        possuiFiltroSelecionado() {
            return this.filtros.empresas.length < this.empresas.length ||
                this.filtros.vendedores.length < this.vendedores.length ||
                this.filtros.datainicio !== this.staticDataInicial ||
                this.filtros.datafim !== this.staticDataFinal
                ? true
                : false;
        },
        clearFilters() {
            this.empresasInner = [];
            this.vendedoresInner = [];
            this.filtros.empresas = this.empresas.map((e) => e.id);
            this.filtros.vendedores = this.vendedores.map((e) => e.id);
            this.filtros.datainicio = this.staticDataInicial;
            this.datainicio = this.staticDataInicial;
            this.filtros.datafim = this.staticDataFinal;
            this.datafim = this.staticDataFinal;
            this.existeFiltrosSelecionado = false;
            this.reloadCharts();
        },
        reloadCharts() {
            this.dataset.forEach((c) => {
                if (this.empresasInner.length > 0) {
                    this.filtros.empresas = this.empresasInner.map((e) => e.id);
                } else {
                    this.filtros.empresas = this.empresas.map((e) => e.id);
                }
                if (this.vendedoresInner.length > 0) {
                    this.filtros.vendedores = this.vendedoresInner.map((e) => e.id);
                } else {
                    this.filtros.vendedores = this.vendedores.map((e) => e.id);
                }
                this.filtros.datainicio = this.datainicio;
                this.filtros.datafim = this.datafim;
                let component = this.$refs[`${c.tipo}-${c.titulo}`][0];
                if (component.cleanChart) component.cleanChart();
                component.loadData();
            });
        },
        /*  Para verificar os vendedores pela primeira vez e 
            verificar se precisa mostrar o combo ou não. */
        startVendedores() {
            this.$store.commit('addLoader');
            this.colaboradorService
                .findListAssociated('')
                .then((r) => {
                    this.showVendedores = r.content && r.content.length > 1;
                    this.vendedores = r.content;
                })
                .catch((e) => {
                    console.error('Erro ao carregar vendedores.', e);
                })
                .finally((_) => {
                    this.$store.commit('removeLoader');
                    this.carregarCartoes();
                });
        },
        loadVendedores(q) {
            this.vendedoresLoading = true;
            this.colaboradorService
                .findListAssociated(q)
                .then((r) => {
                    this.vendedores = r.content;
                })
                .catch((e) => {
                    console.error('Erro ao carregar vendedores.', e);
                })
                .finally((_) => {
                    this.vendedoresLoading = false;
                });
        },
        fetchEmpresas() {
            return (this.$store.state.user.empresas || []).map((empresa) => ({
                idempresa: empresa.idempresa,
                idempresaerp: empresa.idempresaerp,
                nome: empresa.nome,
                rsocial: empresa.rsocial,
                valordecimalplaces: empresa.valordecimalplaces,
                qtdedecimalplaces: empresa.qtdedecimalplaces,
                id: empresa.idempresa,
            }));
        },
        resize() {
            let currentSize = {
                w: document.body.clientWidth,
                h: document.body.clientHeight,
            };
            this.curScreenSize = window.innerWidth;
            if (currentSize.w != this.lastSize.w) this.redrawCharts();
            this.lastSize = currentSize;
        },
        redrawCharts() {
            this.$d3.selectAll('.chart-tooltip').remove();
            this.mountCockpitCharts();
        },
        carregarCartoes() {
            this.$store.commit('addLoader');
            if (this.empresasInner.length == 0) {
                this.filtros.empresas = this.empresas.map((e) => e.id);
            } else {
                this.filtros.empresas = this.empresasInner.map((e) => e.id);
            }
            if (this.vendedoresInner.length == 0) {
                this.filtros.vendedores = this.vendedores.map((e) => e.id);
            } else {
                this.filtros.vendedores = this.vendedoresInner.map((e) => e.id);
            }
            this.filtroCockpitService
                .buscarGraficosComFiltros('despesas')
                .then((res) => {
                    this.filtroList = res.content.filtros;
                    this.getFiltroObject();
                    if (this.vendedoresInner.length > 0) {
                        this.vendedoresResultadoAtual = [...this.vendedoresInner];
                    } else {
                        this.vendedoresResultadoAtual = [...this.vendedores];
                    }
                    this.dataset = res.content.charts;
                })
                .catch((e) => {
                    console.error('Erro ao carregar os cards.', e);
                    this.$root.showMessage('error', 'msg-erro-cockpit');
                })
                .finally((_) => {
                    this.$store.commit('removeLoader');
                    this.mountCockpitCharts();
                });
        },
        getFiltroObject() {
            this.filtroList.forEach((f) => {
                switch (f.tipo) {
                    case 'tipo-analise':
                        this.tipoAnaliseInner = f.valor;
                        this.filtros.tipoAnalise = f.valor;
                        this.filtros.idfiltrotipoanalise = f.idfiltro;
                        break;
                    case 'empresa':
                        if (f.itens.length > 0)
                            this.filtros.empresas = f.itens.map((e) => e.idempresa);
                        this.empresasInner = f.itens;
                        this.filtros.idfiltroempresa = f.idfiltro;
                        break;
                    case 'vendedor':
                        if (f.itens.length > 0)
                            this.filtros.vendedores = f.itens.map((e) => e.idusuario);
                        this.vendedoresInner = f.itens;
                        this.filtros.idfiltrovendedor = f.idfiltro;
                        break;
                    case 'data-inicio':
                        this.filtros.datainicio = f.valor;
                        this.datainicio = new Date(f.valor);
                        this.filtros.idfiltrodatainicio = f.idfiltro;
                        break;
                    case 'data-fim':
                        this.filtros.datafim = f.valor;
                        this.datafim = new Date(f.valor);
                        this.filtros.idfiltrodatafim = f.idfiltro;
                        break;
                }
            });
        },
        mountCockpitCharts() {
            setTimeout(() => {
                if (this.$refs.chartItem && this.$refs.chartItem.length > 0) {
                    if (this.pckr != null) {
                        this.pckr.destroy();
                    }
                    let elemPack = this.$refs.PackeryMagic;
                    this.pckr = new Packery(elemPack, this.packeryOpts);
                    this.pckr.on('dragItemPositioned', (abc) => {
                        this.firstReload = true;
                    });
                    this.$refs.chartItem.forEach((c) => {
                        c.draggable = new Draggable(this.dragOpts, c);
                        this.bindDraggables(c);
                    });
                } else {
                    if (this.pckr != null) {
                        this.pckr.destroy();
                        this.pckr = null;
                    }
                }
            }, 100);
        },
        onSearch(value) {
            var searchValue = value.trim();
            if (searchValue != '') {
                this.searching = true;
                this.resultSet = this.chartsAvailable.filter((c) => {
                    return this.$t(c.nome).search(new RegExp(searchValue, 'i')) > -1;
                });
                this.searchSet = this.resultSet;
            } else {
                this.searching = false;
                this.resultSet = this.chartsAvailable;
            }
            this.getCategories();
        },
        bindDraggables(elem) {
            this.jqi(elem).on('dragstart', this.pckr.handleUIDraggable.start);
            this.jqi(elem).on('drag', this.pckr.handleUIDraggable.drag);
            this.jqi(elem).on('dragstop', this.pckr.handleUIDraggable.stop);
        },
        /*  Esta função serve para poder atualizar o conteúdo do card aqui
            ao invés de alterar a prop dentro do componente dele. */
        updateChart(datacontent, index) {
            this.$set(this.dataset, index, datacontent);
        },
        handleDateChange(nova_data, campo) {
            switch (campo) {
                case 'inicio':
                    this.filtros.datainicio = this.$moment(nova_data).format('YYYY-MM-DD');
                    break;
                case 'fim':
                    this.filtros.datafim = this.$moment(nova_data).format('YYYY-MM-DD');
                    break;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.z-index-1 {
    z-index: 1;
}

#main {
    padding: 0 15px 15px 21px;
    height: auto;
    &.no-charts {
        height: 100%;
    }
    img {
        width: 240px;
        height: 360px;
    }
}
.chart-toolbar .column .card {
    overflow: initial;
}
.page {
    position: relative;
    padding-left: 0;
    background: none;
    box-shadow: none;
}
.hero.is-fullheight {
    min-height: calc(100% - 20px);
}
.footer {
    position: relative;
    bottom: 20px;
    width: 100%;
    /* top: calc(100% - 450px) */
    max-height: 300px;
    display: flex;
    justify-content: space-between;
}
.cockpit {
    position: relative;
    width: 100%;
    margin-bottom: 120px;
}
.cockpit .center p {
    height: 100%;
    margin-bottom: 40px;
    font-size: 20px;
    color: $text-color;
    width: 50%;
    left: 50%;
    position: relative;
    transform: translateX(-50%);
}
.cockpit .center .btn {
    color: $sovis-white;
    padding: 10px 70px;
}
.cockpit .center .elipse {
    margin-bottom: 40px;
    > .big-svg-icons {
        width: 250px;
        height: 125px;
        margin-top: -10px;
    }
}
.no-charts .center {
    top: 50%;
    transform: translate(-50%, -50%);
    .elipse {
        margin-bottom: 20px;
    }
    .big-svg-icons {
        top: 45%;
    }
}
// Modal adicionar gráfico ao cockpit
.modal-card-body .subtitle {
    margin-bottom: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    font-size: 16px;
    color: $primary-color;
}
.manage-charts-link {
    font-size: 14px;
}
.manage-charts-shortcut {
    width: 100%;
    padding: 0 15px 10px 15px;
    display: flex;
    justify-content: flex-end;
}
.tag {
    background-color: $primary-color;
    color: $sovis-white;
}
.categorias {
    @media only screen and (max-width: 500px) {
        display: none !important;
    }
    .column {
        padding: 0.25rem 0.75rem;
        font-size: 14px;
    }
}
.result-set {
    padding: 0.25rem 0.75rem;
    height: calc(100vh - 190px);
    overflow: auto;
}
.no-results {
    height: calc(100vh - 190px);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    color: $text-color;
}
.add-btn,
.delete-btn {
    @media only screen and (max-width: 500px) {
        width: 100%;
    }
    display: flex;
    align-items: center;
    justify-content: center;
    color: $sovis-white;
    font-size: 12px;
    width: 250px;
    height: 35px;
    text-align: center;
    margin-left: 0px;
    padding: 10px;
    border: none;
    border-radius: 6px;
    @include gradient-button();
}
.delete-btn {
    @include exclude-button-2();
}
.chart-container {
    min-height: 600px;
    .chart {
        width: 32%;
        height: auto;
        min-height: 375px !important;

        &.big-number {
            height: 182px !important;
            min-height: unset !important;
        }
        &.speedometer {
            min-height: unset;
        }

        &.line-chart {
            width: 65%;
        }
    }
    .pkry-sizer {
        width: 32%;
    }
    .pkry-gutter {
        width: 1%;
    }
}
.chart-toolbar {
    position: sticky;
    top: 0;
    background: $bg-color; /* Precisa pq se não os elementos vão passar por cima do sticky por ser transparente. */
    z-index: 4;
    /* Se for aumentar esse z-index, verificar dois possíveis pontos de falha
        - O modal do botão "Gerenciar gráficos"
        - O modal do botão de usuário no canto superior direito que ativa quando no modo mobile
    */
    .top-btn {
        height: 36px;
        margin-right: 10px !important;
    }
    .card {
        color: $darker-gray-color;
        .card-header-title {
            color: $darker-gray-color;
            justify-content: space-between;
            padding: 0.3rem;
        }
        .card-content {
            padding: 0.9rem;
            .card-content-top {
                padding-top: 0.25rem;
                padding-bottom: 0.25rem;
            }
        }
    }
    .filtro-header {
        display: flex;
        align-items: center;
    }
    .filtros-extras {
        font-size: 12px;
    }
}

@media only screen and (max-width: 1200px) {
    .chart-container {
        .chart {
            width: 49% !important;
            height: auto !important;
            min-height: 375px !important;
            &.big-number {
                height: 182px !important;
                min-height: unset !important;
            }
            &.speedometer {
                min-height: unset !important;
            }
            &.line-chart {
                width: 99% !important;
            }
        }
        .pkry-sizer {
            width: 49%;
        }
    }
}

@media only screen and (max-width: 860px) {
    .footer {
        display: none;
    }
    .chart-container {
        .chart {
            width: 49% !important;
            height: auto !important;
            min-height: 375px !important;

            &.big-number {
                height: 182px !important;
                min-height: unset !important;
            }

            &.speedometer {
                min-height: unset !important;
            }

            &.line-chart {
                width: 99% !important;
            }
        }
        .pkry-sizer {
            width: 49%;
        }
    }
}

@media only screen and (max-width: 760px) {
    .footer {
        display: none;
    }
    .chart-container {
        .chart {
            width: 100% !important;
            height: auto !important;
            min-height: 375px !important;

            &.big-number {
                min-height: unset !important;
            }
            &.speedometer {
                height: 300px;
            }
            &.line-chart {
                width: 100% !important;
            }
        }
        .pkry-sizer {
            width: 100%;
        }
    }

    .result-set {
        height: calc(100vh - 305px);
    }
}

.disabled {
    opacity: 0.4;
}
</style>
